<app-referrals-standard-listing
  [loadingReferrals]="loadingReferrals"
  [eligibleReferrals]="eligibleReferrals"
  [ineligibleReferrals]="ineligibleReferrals"
  [referralMatchOptions]="referralMatchOptions"
  [showIneligibleReferrals]="showIneligibleReferrals"
  (referralVerificationChange)="onReferralVerificationChange($event)" />
